import InlineSVG from "react-inlinesvg";
import styled from "styled-components/macro";
import IconButton from "./IconButton";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  border-radius: 8px;
  padding: ${(props) => (props.deletable ? "1px 4px 1px 4px" : "4px 8px 3px 4px")};
  border: 1px solid var(--grey-3);
  width: fit-content;

  .icon-button-wrapper {
    &:hover {
      & > div {
        width: 24px;
        height: 24px;
        border-radius: 4px;
      }
    }

    &:active {
      & > div {
        width: 23px;
        height: 23px;
        border-radius: 4px;
      }
    }
  }

  svg {
    path {
      fill: var(--grey-0);
    }
  }

  .label {
    color: var(--grey-0);
  }
`;

export const Tag = ({ src, onDelete, label }) => {
  return (
    <Container deletable={!!onDelete}>
      <InlineSVG
        src={src}
        className="type-icon"
      />
      <p className="label">{label}</p>
      {onDelete && (
        <IconButton
          src="/assets/close.svg"
          onClick={onDelete}
          size={23}
          iconSize={20}
        />
      )}
    </Container>
  );
};
